import { useEffect } from "react";
import { SITE_URL } from "@/lib/site";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const ICONS = [
  { rel: "icon", href: "/favicon.ico", sizes: "any" },
  { rel: "icon", href: "/favicon-192.png", type: "image/png", sizes: "192x192" },
  { rel: "apple-touch-icon", href: "/apple-touch-icon.png" },
];

const ensureIcons = () =>
  ICONS.forEach((attrs) => {
    if (document.head.querySelector(`link[rel="${attrs.rel}"][href="${attrs.href}"]`)) return;
    const el = document.createElement("link");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  });

export const Seo = ({ title, description, path, noindex = false, jsonLd = [], image = "/images/og-image.jpg" }) => {
  const ld = JSON.stringify(jsonLd);

  useEffect(() => {
    const url = `${SITE_URL}${path ?? window.location.pathname}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${SITE_URL}${image}`);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "de_DE");
    setMeta("name", "twitter:card", "summary_large_image");
    setCanonical(url);
    ensureIcons();
    document.head.querySelectorAll("script[data-seo-ld]").forEach((n) => n.remove());
    JSON.parse(ld).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seoLd = "1";
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, path, noindex, image, ld]);

  return null;
};
